module.exports = __webpack_public_path__ + "web-icons.c7c8e6acd4d75aebd95f.svg";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Partners-Pipeline/src/assets/fonts/web-icons/web-icons.svg?v=0.2.3
// module id = ../../../../../src/assets/fonts/web-icons/web-icons.svg?v=0.2.3
// module chunks = styles